var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7763B784-6F8E-479A-8128-4DBA52D1BC67") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "#023B93",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-1019.000000, -456.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1019.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "##023B93",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(11.514731, 11.514731)",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2.81860196,
    y1: 2.83820981,
    x2: 14.1519353,
    y2: 14.1323275,
    id: "Line-3",
    transform: "translate(8.485269, 8.485269) rotate(45.099299) translate(-8.485269, -8.485269) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.81860196,
    y1: 2.83820981,
    x2: 14.1519353,
    y2: 14.1323275,
    id: "Line-3",
    transform: "translate(8.485269, 8.485269) scale(-1, 1) rotate(-44.900701) translate(-8.485269, -8.485269) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPlusIcon);
export default __webpack_public_path__ + "static/media/filled-plus-icon.dd4042ac16261389132088c2188e1286.svg";
export { ForwardRef as ReactComponent };